export default [
  { id: "safety", link: '', disabled: false },
  { id: "privacy", link: '', disabled: true },
  { id: "liability", link: '', disabled: true },
  { id: "quality", link: '', disabled: true },
];
